import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

interface ExternalLinkWarningProps {
  open: boolean;
  url: string;
  onConfirm: () => void;
  onCancel: () => void;
}

function ExternalLinkWarning({ open, url, onConfirm, onCancel }: ExternalLinkWarningProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth='xs' fullWidth aria-labelledby='external-link-dialog-title'>
      <DialogTitle id='external-link-dialog-title' sx={{ fontSize: '18px', fontWeight: 600 }}>
        Leaving ARC Tool
      </DialogTitle>
      <DialogContent>
        <Typography variant='body2' sx={{ mb: 1 }}>
          You are about to open an external link
        </Typography>
        <Box
          sx={{
            backgroundColor: '#f7fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '6px',
            padding: '12px 16px',
            wordBreak: 'break-all',
          }}
        >
          <Typography
            variant='body2'
            sx={{
              fontSize: '14px',
              fontFamily: 'monospace',
            }}
          >
            {url}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button onClick={onCancel} variant='outlined' sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant='contained'
          color='primary'
          disableElevation
          sx={{ textTransform: 'none', color: '#fff' }}
        >
          Visit Site
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ExternalLinkWarning;
